import { useQuery } from '@tanstack/react-query';
import userService from 'api/userService';

export const useAdminAllCustomers = (params) => {
    return useQuery({
        queryKey: ['adminAllCustomers', params],
        queryFn: () => userService.getAllCustomers(params),
        keepPreviousData: true,
        staleTime: 5 * 60 * 1000 // cache for 5 minutes
    });
};

export const useAdminGetCustomerDetails = (customerId) => {
    return useQuery({
        queryKey: ['adminCustomerDetails', customerId],
        queryFn: () => userService.getCustomerById(customerId),
        staleTime: 1 * 1000
    });
};
